<template>
    <div class="body employee-filing">
        <div class="yhead rightsearch">
            <div style="width: 180px;height: 1px;"></div>
            <div class="xzyg" @click="jia">+新增员工</div>
            <div
                style="width: 180px;display: inline-block;vertical-align: middle;margin-left: 10px"
            >
                <el-row style="width: 180px;">
                    <el-col :span="24">
                        <el-input
                            placeholder="请输入姓名"
                            v-model="input5"
                            class="input-with-select"
                            size="small"
                            @keyup.enter.native="search"
                        >
                            <el-button
                                slot="append"
                                type="success"
                                size="small"
                                style="
                              background:#8CBB77;color: #fff;border: 1px solid #8CBB77;border-bottom:0;border-radius: 0  4px 4px 0"
                                icon="el-icon-search"
                                @click="search"
                            ></el-button>
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div style="width: 100%">
            <table class="table table-bordered table-striped table-hover" v-loading="loading2">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>姓名</th>
                        <th>性别</th>
                        <th>电话</th>
                        <th>职位</th>
<!--                        <th>一阶段培训</th>-->
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ta,index) in tabledate" :key="index">
                        <td>{{ta.user_id}}</td>
                        <td>{{ta.username}}</td>
                        <td>{{ta.sex}}</td>
                        <td>{{ta.phone}}</td>
                        <td>{{ta.gangwei}}</td>
<!--                        <td>{{ta.scoresb|yij}}</td>-->
                        <td style="width: 240px">
                            <div class="aply">
                                <i class="fa fa-edit" @click="prop1(ta.user_id)" aria-hidden="true"></i>
                                <i
                                    class="fa fa-trash"
                                    @click="prop2(ta.user_id,ta.username)"
                                    aria-hidden="true"
                                ></i>
<!--                                <span @click="prop3(ta.user_id,ta.erwm)">查看二维码</span>-->
                                <span @click="prop4(ta.user_id,ta)" style="color:#F56C6C">资料建档</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>共{{skjlnum}}条数据，当前第{{curpage}}页</p>
            <div class="table-bottom">
                <div>
                    <el-pagination
                        @current-change="fanye"
                        :page-size="pageone"
                        background
                        :total="skjlnum"
                        :current-page="curpage"
                        layout="prev, pager, next"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <el-dialog
            class="tanchuang"
            :visible.sync="dialogVisible"
            width="650px"
            :close-on-click-modal="false">
            <span slot="title" class="dialog-footer">{{popup === 1 ? '添加员工' : '修改员工信息'}}</span>
            <div>
                <el-row>
                    <el-col :span="12">
                        <div class="prolist">
                            <div style="width: 80px">姓名:</div>
                            <el-row style="width: 180px">
                                <el-col :span="24">
                                    <el-input
                                        v-model="name"
                                        size="small"
                                        style="width: 100%"
                                        placeholder="请输入内容"
                                    ></el-input>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div class="prolist">
                            <div style="width: 80px">性别:</div>
                            <el-row style="width: 180px">
                                <el-col :span="24">
                                    <el-radio v-model="sex" label="男">男</el-radio>
                                    <el-radio v-model="sex" label="女">女</el-radio>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="prolist">
                            <div style="width: 80px">电话:</div>
                            <el-row style="width: 180px">
                                <el-col :span="24" class="jishu">
                                    <el-input
                                        v-model="phone"
                                        size="small"
                                        maxlength="11"
                                        style="width: 100%"
                                    ></el-input>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div class="prolist">
                            <div style="width: 80px">职位:</div>
                            <el-row style="width: 180px">
                                <el-col :span="24">
                                    <el-select
                                        v-model="zhiwei"
                                        size="small"
                                        style="width: 100%"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>

                    <el-col :span="24" style="padding-top: 10px">
                        <div
                            class="prolist"
                            style="height: auto;min-height:25px;justify-content: flex-start;align-items: flex-start "
                        >
                            <div style="width: 97px;">
                                分配权限:
                                <p style="margin-top: 40px">系统:</p>
                                <p style="margin-top: 8px;font-size: 14px">导航:</p>
                            </div>

                            <el-row style="width: 580px;line-height: 25px">
                                <el-col :span="24" class="zhiweibox">
                                    <el-checkbox-group v-model="checkList">
<!--                                        <el-checkbox :label="14">短信</el-checkbox>-->
                                        <el-checkbox :label="1">会员</el-checkbox>
<!--                                        <el-checkbox :label="2">排课</el-checkbox>-->
<!--                                        <el-checkbox :label="3">选课</el-checkbox>-->
                                        <el-checkbox :label="5">活动</el-checkbox>
                                        <el-checkbox :label="6">跟进</el-checkbox>
                                        <el-checkbox :label="7">计次</el-checkbox>
                                        <el-checkbox :label="8">记录</el-checkbox>
                                        <el-checkbox :label="9">合约</el-checkbox>
<!--                                        <el-checkbox :label="26">教案</el-checkbox>-->
                                        <el-checkbox :label="27">进销存</el-checkbox>
                                        <!--<el-checkbox :label="28">绘本</el-checkbox>-->
                                        <!--<el-checkbox :label="29">微营销</el-checkbox>-->
                                        <el-checkbox :label="30">测评</el-checkbox>
<!--                                        <el-checkbox :label="38">新活动</el-checkbox>-->
<!--                                        <el-checkbox :label="42">积分系统</el-checkbox>-->
                                        <br />
                                        <el-checkbox :label="10">员工设置</el-checkbox>
                                        <el-checkbox :label="11">商品设置</el-checkbox>
<!--                                        <el-checkbox :label="12">课程设置</el-checkbox>-->
<!--                                        <el-checkbox :label="41">教室设置</el-checkbox>-->
                                        <!--<el-checkbox :label="37">合约项目</el-checkbox>-->
                                        <br />
<!--                                        <el-checkbox :label="31">测评设置</el-checkbox>-->
<!--                                        <el-checkbox :label="32">测评问询</el-checkbox>-->
<!--                                        <el-checkbox :label="33">专家测评</el-checkbox>-->
<!--                                        <el-checkbox :label="34">活动统计</el-checkbox>-->
<!--                                        <el-checkbox :label="35">测评结算</el-checkbox>-->
<!--                                        <el-checkbox :label="36">员工分成</el-checkbox>-->
<!--                                        <el-checkbox :label="39">官网系统</el-checkbox>-->
                                        <el-checkbox :label="40">品牌运营5S系统</el-checkbox>
<!--                                        <el-checkbox :label="48">培训视频</el-checkbox>-->
                                        <br />
<!--                                        <el-checkbox :label="43">积分审核</el-checkbox>-->
<!--                                        <el-checkbox :label="44">积分考核</el-checkbox>-->
                                        <!--<el-checkbox :label="45">积分申请</el-checkbox>-->
<!--                                        <el-checkbox :label="46">积分规则</el-checkbox>-->
<!--                                        <el-checkbox :label="47">数据统计</el-checkbox>-->
                                        <!--<el-checkbox :label="96">食谱</Del-checkbox>-->
                                        <!--<el-checkbox :label="96">食谱</Del-checkbox>-->
                                        <!--<el-checkbox :label="97">监控画面</el-checkbox>-->
                                        <!--<el-checkbox :label="98">预约管理</el-checkbox>-->
                                        <!--<el-checkbox :label="99">体温记录</el-checkbox>-->
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="prolist">
                            <div style="width: 80px">是否测评师:</div>
                            <el-row style="width: 180px">
                                <el-col :span="24" class="jishu" style="margin-left: 6px;">
                                    <el-checkbox v-model="cpteacher"></el-checkbox>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <div @click="handleSubmit" class="xzyg" style="margin:0 auto">{{popup === 1 ? '确认添加' : '确认修改'}}</div>
            </span>
        </el-dialog>

        <el-dialog class="tanchuang" :visible.sync="dialogVisible2" width="300px">
            <span slot="title" class="dialog-footer">员工离职</span>
            <div>确认员工({{xingm}})离职吗</div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
                <el-button size="small" type="success" @click="shanchuyg">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            class="tanchuang"
            :visible.sync="dialogVisible3"
            width="250px"
            :close-on-click-modal="false">
            <span slot="title" class="dialog-footer">查看二维码</span>
            <div v-loading="loading3">
                <img style="width: 100%;height:200px;" :src="erwm" alt />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible3 = false">取 消</el-button>
                <a
                    target="_blank"
                    :href="baseUrl + 'saas/yuangon/xiazai?user_id='+uid+'&token='+token"
                >
                    <el-button size="small" type="success">下载二维码</el-button>
                </a>
            </span>
        </el-dialog>

        <!-- 建档 弹窗 -->
        <el-dialog
            class="tanchuang ziliaoBox"
            :visible.sync="dialogVisible5"
            width="930px"
            :close-on-click-modal="false"
        >
            <span slot="title" class="dialog-footer">信息查看</span>
            <div style="padding-left: 20px;position:relative">
                <el-row>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">姓名</div>
                            <el-input
                                v-model="archives.username"
                                size="mini"
                                disabled="disabled"
                                placeholder="请输入内容"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">职位</div>
                            <el-input
                                v-model="archives.gangwei"
                                size="mini"
                                disabled="disabled"
                                placeholder="请输入内容"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">电话</div>
                            <el-input
                                v-model="archives.phone"
                                size="mini"
                                disabled="disabled"
                                placeholder="请输入内容"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">入职时间</div>
                            <el-date-picker
                                style="width: 180px"
                                size="mini"
                                v-model="archives.ruzhi"
                                align="right"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择入职时间"
                            ></el-date-picker>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">学历</div>
                            <el-select
                                v-model="archives.xueli"
                                placeholder="请选择学历"
                                style="width: 180px"
                                size="mini"
                            >
                                <el-option
                                    v-for="item in xueliOption"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">身份证号</div>
                            <el-input
                                v-model="archives.shenfenzheng"
                                size="mini"
                                placeholder="请输入身份证号"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">民族</div>
                            <el-input
                                v-model="archives.minzu"
                                size="mini"
                                placeholder="请输入民族"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">出生日期</div>
                            <el-date-picker
                                style="width: 180px"
                                size="mini"
                                v-model="archives.chusheng"
                                align="right"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择出生日期"
                            ></el-date-picker>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">籍贯</div>
                            <el-input
                                v-model="archives.jiguan"
                                size="mini"
                                placeholder="请输入籍贯"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">婚育状况</div>
							<el-select
                                v-model="archives.hunyu"
                                placeholder="请选择婚育状况"
                                style="width: 180px"
                                size="mini"
                            >
                                <el-option
                                    v-for="item in hunyuOpt"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">职级</div>
							<el-select
                                v-model="archives.zhiji"
                                placeholder="请选择户口类型"
                                style="width: 180px"
                                size="mini"
                            >
                                <el-option
                                    v-for="item in zhijiOpt"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">电子邮件</div>
                            <el-input
                                v-model="archives.email"
                                size="mini"
                                placeholder="请输入电子邮件"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">户口类型</div>
							<el-select
                                v-model="archives.hukou"
                                placeholder="请选择户口类型"
                                style="width: 180px"
                                size="mini"
                            >
                                <el-option
                                    v-for="item in hukouOpt"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.name"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">备注</div>
                            <el-input
                                v-model="archives.beizhu"
                                size="mini"
                                placeholder="请输入备注"
                                style="width: 180px"
                            ></el-input>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 10px">
                    <el-col>
                        <div class="prolist">
                            <div class="tit">家庭住址</div>
                            <el-select
                                v-model="prov"
                                style="width: 180px;margin-right:10px"
                                size="mini"
                                placeholder="请选择省份"
                                @change="updateCity();updateDistrict()"
                            >
                                <el-option
                                    v-for="option in allCity.slice(1)"
                                    :key="option.name"
                                    :label="option.name "
                                    :value="option.name"
                                ></el-option>
                            </el-select>
                            <el-select
                                @change="updateDistrict()"
                                v-model="city"
                                style="width: 180px;margin-right:10px"
                                size="mini"
                                placeholder="请先选择省份"
                            >
                                <el-option
                                    v-for="option in cityArr.slice(1)"
                                    :key="option.name"
                                    :label="option.name "
                                    :value="option.name"
                                ></el-option>
                            </el-select>
                            <el-select
                                v-model="district"
                                v-if="district"
                                style="width: 180px;margin-right:10px"
                                size="mini"
                            >
                                <el-option
                                    v-for="option in districtArr.slice(1)"
                                    :key="option.name"
                                    :label="option.name "
                                    :value="option.name"
                                ></el-option>
                            </el-select>
                            <el-input
                                type="text"
                                v-model="archives.zhuzhi"
                                size="mini"
                                style="width: 180px"
                                placeholder="详细地址"
                                clearable
                            ></el-input>
                        </div>
                    </el-col>
                </el-row>

                <el-row v-show="false">
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">总部认证培训:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <ul class="zbrenzhengWrap">
                                        <div
                                            class="zbrenzheng"
                                            :class="{'activeRz': archives.scoresb==1}"
                                        >一阶培训</div>
                                        <div
                                            class="zbrenzheng"
                                            :class="{'activeRz': archives.scoresc==1}"
                                        >二阶培训</div>
                                        <div
                                            class="zbrenzheng"
                                            :class="{'activeRz': archives.scoresd==1}"
                                        >三阶培训</div>
                                    </ul>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <el-row v-show="false">
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">其他认证培训:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <el-checkbox-group v-model="archives.renzheng">
                                        <el-checkbox label="感统培训"></el-checkbox>
                                        <el-checkbox label="测评证书"></el-checkbox>
                                        <el-checkbox label="云编程证书"></el-checkbox>
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <el-row v-show="false">
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">兼职事项:</div>
                            <el-row style="width: 780px;padding-top:4px;">
                                <el-col :span="24">
                                    <el-checkbox-group v-model="archives.jianzhi">
                                        <el-checkbox label="采购"></el-checkbox>
                                        <el-checkbox label="HR招聘"></el-checkbox>
                                        <el-checkbox label="公众号运营"></el-checkbox>
                                        <el-checkbox label="库管"></el-checkbox>
                                        <el-checkbox label="财务" style="width:90px"></el-checkbox>
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <el-row v-show="false">
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">特长:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <el-checkbox-group v-model="archives.techang">
                                        <el-checkbox label="英语4级及以上"></el-checkbox>
                                        <el-checkbox label="舞蹈考级证书"></el-checkbox>
                                        <el-checkbox label="乐器考级证书"></el-checkbox>
                                        <el-checkbox label="主持认证证书"></el-checkbox>
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
                <div class="jiandang-upload">
                    <el-upload
                        class="avatar-uploader"
                        action="https://wxapi.momyhome.cn/index/baoming/upload_head_img"
                        name="img_upload"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                    >
                        <img v-if="archives.img" :src="archives.img" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <p class="upload-tip">一寸照片</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div @click="submitArchives" class="xzyg" style="margin:0 auto">确认</div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//import '../static/qmsj/css/table.css'
import { cityList } from "../../../static/qmsj/js/city";
export default {
    data() {
        return {
            token: "",
            falsea: false,
            input5: "",
            dialogVisible: false,
            cpteacher: "",
            dialogVisible4: false,
            name: "",
            sex: "男",
            phone: "",
            zhiwei: [],
            options: [
                {
                    value: "店长",
                    label: "店长"
                },
                {
                    value: "前台",
                    label: "前台"
                },
                {
                    value: "顾问",
                    label: "顾问"
                },
                {
                    value: "市场",
                    label: "市场"
                },
                {
                    value: "技师",
                    label: "技师"
                }
            ],
            value: "",
            checkList: [],
            zhiweibox: "",
            shez: "",
            dialogVisible2: false,
            dialogVisible3: false,
            loading2: false,
            loading3: false,
            tabledate: "",
            pageone: 10,
            skjlnum: 100,
            curpage: 1,
            uid: "",
            xingm: "",
            erwm: "",
            dialogVisible5: false,
            archives: {
                username: "",
                user_id: "",
                ruzhi: "",
                jiguan: "",
                minzu: "",
                chusheng: "",
                shenfenzheng: "",
                hunyu: "",
                zhiji: "",
                email: "",
                hukou: "",
                xueli: "",
                beizhu: "",
                sheng: "",
                shi: "",
                qu: "",
                zhuzhi: "",

                jianzhi: [],
                techang: [],
                renzheng: [],
                gangwei: "",
                phone: "",
                scoresb: "",
                scoresc: "",
                scoresd: "",
                zongbu: []
            },
            xueliOption: ["本科以上", "本科", "专科、大专"],
            baseUrl: "",
            allCity: cityList,
            prov: "", // 省
            city: "", // 市
            district: "", // 地区
            cityArr: [],
            districtArr: [],
			detailAddr: "",
			//婚育
			hunyuOpt: [{
					name: '已婚'
				},
				{
					name: '未婚'
				},
			],
			//户口
			hukouOpt: [{
					name: '农业户口'
				},
				{
					name: '非农业户口'
				},
			],
			//职级
			zhijiOpt: [{
					name: '幼教一级'
				},
				{
					name: '幼教二级'
				},
				{
					name: '幼教高级'
				},
				{
					name: '其它'
				},
            ],
            popup: 1,    //  1- 新增员工； 2-修改员工资料
        };
    },
    created() {
        this.baseUrl = process.env.apiUrl;
    },
    methods: {
        xzhi: function() {
            let self = this;
            $.ajax({
                type: "post",
                url: process.env.apiUrl + "saas/yuangon/quanx",
                dataType: "json",
                data: {
                    token: self.token,
                    gangwei: self.zhiwei
                },
                success: function(data) {
                    self.checkList = data;
                }
            });
        },
        jump: function(d) {
            this.$router.push(d);
        },
        // 点击  添加员工按钮 函数
        jia: function() {
            this.popup = 1
            this.name = ''
            this.sex = ''
            this.phone = ''
            this.zhiwei = ''
            this.checkList = []
            this.dialogVisible = true;
        },
        // 点击 修改员工资料函数
        prop1: function(iid) {
            this.uid = iid;
            this.dialogVisible = true;
            this.popup = 2
            let self = this;
            $.ajax({
                type: "post",
                url: process.env.apiUrl + "saas/yuangon/xiu1",
                dataType: "json",
                data: {
                    token: self.token,
                    user_id: iid
                },
                success: function(data) {
                    self.name = data.username;
                    self.sex = data.sex;
                    self.phone = data.phone;
                    self.zhiwei = data.gangwei;
                    let arra = data.nav_id.split(",");

                    let newarr = [];
                    for (let x in arra) {
                        newarr[x] = Number(arra[x]);
                    }
                    self.checkList = newarr;
                    if (data.cp_teacher == 2) {
                        self.cpteacher = true;
                    } else {
                        self.cpteacher = false;
                    }
                },
                error: function() {
                    self.$message.error(`请求失败`);
                }
            });
        },
        prop2: function(iid, xing) {
            this.uid = iid;
            this.dialogVisible2 = true;
            this.xingm = xing;
        },
        shanchuyg: function() {
            let self = this;
            $.ajax({
                type: "post",
                url: process.env.apiUrl + "saas/yuangon/del",
                dataType: "json",
                data: {
                    token: self.token,
                    user_id: self.uid
                },
                success: function(data) {
                    if (data.status == 1) {
                        self.$message.success(`删除成功！`);
                        self.dialogVisible2 = false;
                        self.gonggong();
                    } else {
                        self.$message.error(`请检查您的网络,稍后重试`);
                    }
                },
                error: function() {
                    self.$message.error(`请求失败`);
                }
            });
        },
        prop3: function(id, erw) {
            this.dialogVisible3 = true;
            let self = this;
            self.uid = id;
            if (erw) {
                $.ajax({
                    type: "post",
                    url: process.env.apiUrl + "saas/yuangon/erlist",
                    dataType: "json",
                    data: {
                        token: self.token,
                        user_id: self.uid
                    },
                    beforeSend: function(xhr) {
                        self.loading3 = true;
                    },
                    success: function(data) {
                        self.loading3 = false;
                        if (data.status) {
                            self.$message.error(`${data.msg}!`);
                        } else {
                            self.erwm = data.erwm;
                        }
                    },
                    error: function(data) {
                        self.loading3 = false;
                        self.$message.error(`请求失败!`);
                    }
                });
            } else {
                $.ajax({
                    type: "post",
                    url: process.env.apiUrl + "saas/yuangon/erm",
                    dataType: "json",
                    data: {
                        token: self.token,
                        user_id: self.uid
                    },
                    beforeSend: function(xhr) {
                        self.loading3 = true;
                    },
                    success: function(data) {
                        if (data.status == 1) {
                            $.ajax({
                                type: "post",
                                url:
                                    process.env.apiUrl +
                                    "saas/yuangon/erlist",
                                dataType: "json",
                                data: {
                                    token: self.token,
                                    user_id: self.uid
                                },
                                beforeSend: function(xhr) {
                                    self.loading3 = true;
                                },
                                success: function(data) {
                                    self.loading3 = false;
                                    if (data.status) {
                                        self.$message.error(`${data.msg}!`);
                                    } else {
                                        self.erwm = data.erwm;
                                    }
                                },
                                error: function(data) {
                                    self.loading3 = false;
                                    self.$message.error(`请求失败!`);
                                }
                            });
                        } else {
                            self.loading3 = false;
                            self.$message.error(`${data.msg}!`);
                        }
                    },
                    error: function(data) {
                        self.$message.error(`生成二维码失败!`);
                    }
                });
            }
        },
        fanye: function(i) {
            let self = this;
            self.curpage = i;
            self.gonggong();
        },
        search: function() {
            let self = this;
            self.curpage = 1;
            self.gonggong();
        },
        gonggong: function() {
            let self = this;
            $.ajax({
                type: "POST",
                url: process.env.apiUrl + "saas/yuangon/index",
                data: {
                    token: self.token,
                    p: self.curpage,
                    name: self.input5
                },
                beforeSend: function(xhr) {
                    self.loading2 = true;
                },
                success: function(data) {
                    self.loading2 = false;
                    self.tabledate = data.data;
                    self.skjlnum = data.num;
                },
                error: function(data) {
                    self.dialogVisible2 = false;
                    self.$message.error(`请求失败!`);
                }
            });
        },
        // 添加员工 或者 修改员工 弹窗提交函数
        handleSubmit: function() {
            let self = this;
            var regx = /^(1[3-9])\d{9}$/;
            if (!regx.test(self.phone.toString())) {
                self.$message.error(`请输入正确的手机号`);
                return;
            }
            let url = process.env.apiUrl + ( this.popup === 1 ? "saas/yuangon/add" : "saas/yuangon/xiu" )
            var cp_teacher = 1;  //默认不是测评师
            if (self.cpteacher) {
                cp_teacher = 2;
            }
            $.ajax({
                type: "POST",
                url: url,
                data: {
                    token: self.token,
                    user_id: self.popup === 1 ? null : self.uid,
                    username: self.name,
                    gangwei: self.zhiwei,
                    phone: self.phone,
                    nav_id: self.checkList,
                    sex: self.sex,
                    cp_teacher: cp_teacher
                },
                success: function(data) {
                    if (data.status == 1) {
                        self.name = "";
                        self.zhiwei = "";
                        self.phone = "";
                        self.sex = "男";
                        self.checkList = "";
                        self.cpteacher = "";
                        self.$message.success( self.popup === 1 ? '添加成功' : `修改成功!`);
                        self.dialogVisible = false;
                        self.gonggong();
                    } else {
                        self.$message.error(data.msg);
                    }
                },
                error: function(data) {
                    self.$message.error(`请求失败!`);
                }
            });
        },
        prop4: function(id, item) {
            this.dialogVisible5 = true;
            let loadingInstance = this.$loading();
            let that = this;
            $.ajax({
                url: process.env.apiUrl + "saas/yuangon/get_files",
                type: "post",
                data: {
                    user_id: id,
                    token: that.token
                },
                success: function(res) {
                    if (res.status == 1) {
                        that.archives = res.data;
                        res.data.sheng && (that.prov = res.data.sheng);
                        res.data.shi && (that.city = res.data.shi);
                        res.data.qu && (that.district = res.data.qu);
                    } else {
                        that.$message.error(res.msg);
                    }
                },
                fail: function(err) {
                    that.$message.error(err);
                },
                complete: function() {
                    loadingInstance.close();
                    that.archives.username = item.username;
                    that.archives.user_id = item.user_id;
                }
            });
        },
        submitArchives() {
            if (this.archives.xueli == "") {
                this.$message.warning("请选择学历");
                return;
            }
            if (this.archives.ruzhi == "") {
                this.$message.warning("请选择入职时间");
                return;
            }
            if (this.archives.shenfenzheng == "") {
                this.$message.warning("请输入身份证号");
                return;
            }
            let loadingInstance = this.$loading();
            this.archives.token = this.token;

            this.archives.sheng = this.prov;
            this.archives.shi = this.city;
            this.archives.qu = this.district;

            let that = this;
            $.ajax({
                url: process.env.apiUrl + "saas/yuangon/update_files",
                type: "post",
                data: that.archives,
                success: function(res) {
                    if (res.status == 1) {
                        that.$message.success(res.msg);
                        that.dialogVisible5 = false;
                        that.gonggong();
                    } else {
                        that.$message.error(res.msg);
                    }
                },
                fail: function(err) {
                    that.$message.error(err);
                },
                complete: function() {
                    loadingInstance.close();
                }
            });
        },
        //省市区三级联动
        updateCity: function() {
            for (var i in this.allCity) {
                var obj = this.allCity[i];
                if (obj.name === this.prov) {
                    this.cityArr = obj.sub;
                    break;
                }
            }
            this.city = this.cityArr[1].name;
        },
        updateDistrict: function() {
            for (var i in this.cityArr) {
                var obj = this.cityArr[i];
                if (obj.name === this.city) {
                    this.districtArr = obj.sub;
                    break;
                }
            }
            if (
                this.districtArr &&
                this.districtArr.length > 0 &&
                this.districtArr[1].name
            ) {
                this.district = this.districtArr[1].name;
            } else {
                this.district = "";
            }
        },
        handleAvatarSuccess(res, file) {
            this.archives.img = res.imgfile;
        },
        beforeAvatarUpload(file) {
            const isLt4M = file.size / 1024 / 1024 < 4;

            if (!isLt4M) {
                this.$message.error("上传头像图片大小不能超过 4MB!");
            }
            return isLt4M;
        },
        // 关闭建档弹窗 初始化数据
        init() {
            this.archives = {
                username: "",
                user_id: "",
                ruzhi: "",
                jiguan: "",
                minzu: "",
                chusheng: "",
                shenfenzheng: "",
                hunyu: "",
                zhiji: "",
                email: "",
                hukou: "",
                xueli: "",
                beizhu: "",
                sheng: "",
                shi: "",
                qu: "",
                zhuzhi: "",
                jianzhi: [],
                techang: [],
                renzheng: [],
                gangwei: "",
                phone: "",
                scoresb: "",
                scoresc: "",
                scoresd: "",
                zongbu: [],
                img: ""
            };
            this.prov = "";
            this.city = "";
            this.district = "";
            this.imageUrl = "";
            this.cityArr = [];
            this.districtArr = [];
        }
    },
    watch: {
        dialogVisible5(val) {
            if (!val) {
                this.init();
            }
        },
    },
    filters: {
        yij: function(arg) {
            if (arg == 0) {
                return "未培训";
            } else if (arg == 1) {
                return "结业";
            } else if (arg == 2) {
                return "不合格";
            } else {
                return "暂无数据";
            }
        }
    },
    mounted: function() {
        let self = this;
        self.token = self.$cookies.get("token");
        $.ajax({
            type: "post",
            url: process.env.apiUrl + "saas/yuangon/index",
            dataType: "json",
            data: {
                token: self.token
            },
            beforeSend: function(xhr) {
                self.loading2 = true;
            },
            success: function(data) {
                self.tabledate = data.data;
                self.skjlnum = data.num;
                self.curpage = 1;
                self.loading2 = false;
            },
            error: function() {
                self.$message.error(`请求失败`);
                self.loading2 = false;
            }
        });
    }
};
</script>

<style scoped>
.body {
    padding-left: 45px;
    padding-right: 45px;
    font-size: 14px;
    color: #666;
}

ul {
    list-style: none;
}

.yhead {
    height: 80px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
}

.xzyg {
    width: 135px;
    height: 32px;
    color: white;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    background: #8CBB77;
    cursor: pointer;
}

.aply {
    width: 240px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    align-items: center;
}

.aply i {
    font-size: 18px;
    color: #666;
    cursor: pointer;
}

.aply span {
    cursor: pointer;
}

.aply span:hover {
    color: #8CBB77;
}

.aply i:hover {
    color: #8CBB77;
}

.prolist {
    height: 40px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
}
.upload-tip {
    text-align: center;
    line-height: 30px;
    font-weight: 600;
}
</style>
<style lang="less">
.employee-filing {
    .jiandang-upload {
        position: absolute;
        top: 0;
        right: 80px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .el-upload__input {
            display: none !important;
        }
    }
    .avatar-uploader .el-upload:hover {
        border-color: #8CBB77;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 140px;
        height: 140px;
        line-height: 140px;
        text-align: center;
    }
    .avatar {
        width: 140px;
        height: 140px;
		display: block;
		margin: 0 auto!important;
		border-radius: unset!important;
    }

    .rightsearch .el-input__inner {
        border-radius: 15px 0 0 15px;
        border: 1px solid #8CBB77;
    }

    .rightsearch .el-input-group__append {
        border-radius: 0 15px 15px 0;
        overflow: hidden;
        border: 1px solid #8CBB77;
    }

    .tanchuang.ziliaoBox .el-dialog {
        margin-top: 7vh !important;
    }
    .tanchuang .el-dialog__header {
        padding: 10px 20px 5px;
        color: #fff;
        background: #8CBB77;
    }
    .ziliaoBox .el-dialog__header {
        border-radius: 0 !important;
    }
    .tanchuang .el-dialog__headerbtn {
        right: 10px;
        top: 10px;
        color: #fff;
    }

    .tanchuang .el-dialog__headerbtn i {
        color: #fff;
    }

    .jishu .el-input-number__decrease,
    .jishu .el-input-number__increase {
        display: none;
    }

    .table-bottom {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        display: -webkit-flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .el-dialog__body {
        text-align: left !important;
    }
    .ziliaoBox {
        border-radius: 20px;
    }
    .ziliaoBox .el-dialog__header {
        border-radius: 0 !important;
    }
    .prolist {
        height: 40px;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
    }
    .ziliaoBox .el-checkbox {
        width: 110px;
    }
    .ziliaoBox .el-checkbox + .el-checkbox {
        margin-left: 24px;
    }
    .xzyg {
        width: 135px;
        height: 32px;
        color: white;
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        background: #8CBB77;
        cursor: pointer;
    }
    .infoBox {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        width: 150px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    .tit {
        margin-right: 10px;
        width: 70px;
        height: 40px;
        text-align: justify;
        line-height: 40px;
    }
    .tit:after {
        content: ":";
        width: 100%;
        display: inline-block;
        overflow: hidden;
        height: 0;
    }
    .mask {
        width: 100%;
        height: 70%;
        position: absolute;
        top: 40px;
        left: 0;
    }
    .zbrenzhengWrap {
        display: flex;
    }
    .zbrenzheng {
        margin-right: 30px;
        width: 80px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #c0c4cc;
        cursor: pointer;
    }
    .activeRz {
        border: 1px solid #b3d8ff;
        border-radius: 4px;
        color: #8CBB77;
        background: #ecf5ff;
    }
    .zhiweibox .el-checkbox {
        width: 90px;
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/xitong/yuangs.vue